export const WORK_ITEMS = [
  {
    id: "nexa",
    title: "NEXA",
    category: "Growth Marketing Platform",
    image: "/images/concept-nexa.png",
    tags: ["Brand System", "Editorial Layout", "Conversion Design"],
    metric: "+240% qualified engagement",
    year: "2026",
    description:
      "A data-led marketing studio site built around oversized editorial typography, a live growth chart hero, and a service grid engineered to funnel visitors straight into strategy calls.",
    stack: ["React", "Motion Design", "CMS Architecture"],
  },
  {
    id: "ridgeline",
    title: "RIDGELINE",
    category: "Roofing & Exteriors",
    image: "/images/concept-ridgeline.png",
    tags: ["Lead Engine", "Trust Signals", "Project Gallery"],
    metric: "3.8x estimate requests",
    year: "2026",
    description:
      "A heavyweight trade-brand platform pairing bold condensed type with proof-first design — warranties, project counts and licensing placed exactly where customers decide.",
    stack: ["Full-Stack Build", "Quote Funnel", "Local SEO"],
  },
  {
    id: "apex",
    title: "APEX",
    category: "Automotive Detailing",
    image: "/images/concept-apex.png",
    tags: ["Dark Luxury UI", "Booking Flow", "Pricing Tiers"],
    metric: "#1 regional booking rate",
    year: "2026",
    description:
      "A black-on-black luxury detailing experience with cinematic car photography, chrome type treatments, and a package flow that turns browsers into booked appointments.",
    stack: ["Immersive UI", "Booking System", "Art Direction"],
  },
];
